import { render, staticRenderFns } from "./PageMealSkeleton.vue?vue&type=template&id=2f52d05c"
import script from "./PageMealSkeleton.vue?vue&type=script&lang=js"
export * from "./PageMealSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageMealSkeleton.vue?vue&type=style&index=0&id=2f52d05c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports